import { render, staticRenderFns } from "./PushMessageTable.vue?vue&type=template&id=7bf5571e"
import script from "./PushMessageTable.vue?vue&type=script&lang=js"
export * from "./PushMessageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports